import { Component } from "vue";

/**
 * * Модель кастомного виджета
 */
export class CustomWidgetModel<T> {
  /**Идентификатор дата атрибута */
  DataId!: string | number;
  /**Компонент */
  Component: Component;
  /**Пропсы для компонента */
  Props: T;
  /**Обработчики событий */
  Listeners: Record<string, Function> = {};

  constructor(obj?: Partial<CustomWidgetModel<T>>) {
    Object.assign(this, obj);
  }
}
